import React from 'react';

/**
 * Canvas-column placeholder while the document and drawing state catch up to
 * the URL. Keeps the picker and Setup form from painting during boot.
 */
const WorkspaceSkeleton: React.FC = () => (
  <div
    data-testid="workspace-skeleton"
    style={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f3f4f6',
      borderRadius: 12,
      color: '#6b7280',
      fontSize: 14,
      minHeight: 240,
      width: '100%',
      height: '100%',
    }}
  >
    Loading drawing…
  </div>
);

export default WorkspaceSkeleton;
